_getUserPortalResources